import React from "react"

const QuestaoSingle = ({ questao, updateQuestion, nrQuestao}) => {
  return (  
      
    <div className="questao">
      <div className="questao-title">
        <span className="questao-number">{nrQuestao}. </span>
        <span>{questao.Title}</span>
      </div>
      <div className="questao-buttons">
          {questao.Respostas.map(x => { return(
                  <div className="" >
                    <a className="botao-questao" 
                    style={
                      {backgroundColor: x.Selected ? 'var(--off-color)': '',
                       color: x.Selected ? 'whitesmoke': '' }} 
                      onClick={() => updateQuestion(x)}><div>{x.Title}</div></a>                    
                  </div>
                
          )})      
          }
             <div></div>
      </div>
    </div>
  )
}

export default QuestaoSingle
